import { type RootState } from '../../stores/redux';

export const getInstitution = (state: RootState) =>
  state.institution.institution;

export const getInstitutionId = (state: RootState) =>
  state.institution.institution?.id;
